import { render, staticRenderFns } from "./OwalFileInput.vue?vue&type=template&id=02b5319e&scoped=true"
import script from "./OwalFileInput.vue?vue&type=script&lang=js"
export * from "./OwalFileInput.vue?vue&type=script&lang=js"
import style0 from "./OwalFileInput.vue?vue&type=style&index=0&id=02b5319e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5319e",
  null
  
)

export default component.exports